import { createContext } from "react";

type Organization = {
  organizationId: string | null;
}
const OrganizationContext = createContext<Organization>({ organizationId: null });

export default OrganizationContext;
